import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import About from './components/About';
import Vision from './components/Vision';
import Ecosystem from './components/Ecosystem';
import Tokenomics from './components/Tokenomics';
import Partnerships from './components/Partnerships';
import Staking from './components/Staking';
import Utility from './components/Utility';
import Liquidity from './components/Liquidity';
import Roadmap from './components/Roadmap';
import Security from './components/Security';
import ReikiSessions from './components/ReikiSessions';
import MeetFounder from './components/MeetFounder';
import MerchSection from './components/MerchSection';
import Footer from './components/Footer';
import WhitepaperSection from './components/WhitepaperSection';

function App() {
  return (
    <div className="min-h-screen bg-[#030014] text-slate-50 selection:bg-purple-500/30">
      <Navbar />
      <main>
        {/* PRIMARY FOCUS: Reiki & Wellness */}
        <Hero />
        <ReikiSessions />
        
        {/* SECONDARY FOCUS: Merch */}
        <MerchSection />
        
        {/* BRAND BACKGROUND */}
        <MeetFounder />
        <Vision />
        
        {/* TERTIARY FOCUS: Crypto Ecosystem */}
        <div id="about">
          <About />
        </div>
        <TrustBar />
        <div id="ecosystem">
          <Ecosystem />
        </div>
        <div id="tokenomics">
          <Tokenomics />
        </div>
        <div id="staking">
          <Staking />
        </div>
        <div id="whitepaper">
          <WhitepaperSection />
        </div>
        <Partnerships />
        <Liquidity />
        <Utility />
        <Security />
        <div id="roadmap">
          <Roadmap />
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default App;